import { atom } from 'jotai';
import { $ABTest, $CurrentABTest, $EnterABTest } from './ab-test';
import { $AppIdConfig } from './app-id-config';
import { $Crawler } from './crawler';
import { $CSPScripts } from './csp-scripts';
import { $DOMReadyState } from './dom';
import { $I18nText } from './i18n-text';
import { $InstalledRelatedApp } from './installed-related-app';
import { $Locale } from './locale';
import { $Location, $SearchParams } from './remix';
import { $RenderConfig } from './render-config';
import { $ServerContext } from './server-context';
import { $UserAgent } from './user-agent';
import { $WebUser } from './web-user';
import { $AdditionalScripts } from './additional-scripts';
import { $USPreBanState } from './us-pre-ban-state';
import { $USBanInfo } from './us-ban-info';
import { $FallbackGpToApk } from './fallback_gp_to_apk';
import { $RootLoaderLoaded } from './load-status';
import { $EmailTraffic } from './email-traffic';
import { $EnterTraffic, $CurrentTraffic } from './traffic';
import { $RootReady } from './root-ready';
import { $PSM } from './psm';
import { $DeploymentVDC } from './deployment-vdc';
export * from './ab-test';
export * from './crawler';
export * from './i18n-text';
export * from './locale';
export * from './render-config';
export * from './root-traffic';
export * from './user-agent';
export * from './web-user';
export * from './csp-scripts';
export * from './remix';
export * from './app-id-config';
export * from './server-context';
export * from './dom';
export * from './installed-related-app';
export * from './additional-scripts';
export * from './us-pre-ban-state';
export * from './us-ban-info';
export * from './fallback_gp_to_apk';
export * from './load-status';
export * from './email-traffic';
export * from './traffic';
export * from './root-ready';
export * from './psm';
export * from './deployment-vdc';
export const $SPAReady = atom(false);
export const BuiltinAtoms = {
    $I18nText,
    $WebUser,
    $RenderConfig,
    $Locale,
    $UserAgent,
    $EnterABTest,
    $CurrentABTest,
    $CSPScripts,
    $AppIdConfig,
    $Crawler,
    $DOMReadyState,
    $InstalledRelatedApp,
    $Location,
    $SearchParams,
    $ServerContext,
    $ABTest,
    $AdditionalScripts,
    $USPreBanState,
    $USBanInfo,
    $FallbackGpToApk,
    $SPAReady,
    $EmailTraffic,
    $RootLoaderLoaded,
    $EnterTraffic,
    $CurrentTraffic,
    $RootReady,
    $PSM,
    $DeploymentVDC,
};
export const BuiltinWritableAtoms = {
    $I18nText,
    $WebUser,
    $RenderConfig,
    $Locale,
    $UserAgent,
    $EnterABTest,
    $CurrentABTest,
    $CSPScripts,
    $AppIdConfig,
    $Crawler,
    $DOMReadyState,
    $InstalledRelatedApp,
    $Location,
    $SearchParams,
    $ServerContext,
    $AdditionalScripts,
    $USPreBanState,
    $USBanInfo,
    $FallbackGpToApk,
    $RootLoaderLoaded,
    $EnterTraffic,
    $CurrentTraffic,
    $PSM,
    $DeploymentVDC,
};
